module.exports = __webpack_public_path__ + "static/media/logo_login_baru.4817d44f.png";